export const AVATAR_GRADIENTS = [
    ["#4ADE80", "#16A34A"],
    ["#38BDF8", "#0284C7"],
    ["#FCD34D", "#D97706"],
    ["#C084FC", "#7C3AED"],
    ["#FB7185", "#BE123C"],
    ["#FB923C", "#C2410C"],
    ["#34D399", "#059669"],
    ["#A78BFA", "#5B21B6"],
];

export const getAvatarColors = (name = "") => {
    if (!name || typeof name !== "string") return AVATAR_GRADIENTS[0];
    return AVATAR_GRADIENTS[name.charCodeAt(0) % AVATAR_GRADIENTS.length];
};